var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-list"},_vm._l((this.lists),function(item,index){return _c('div',{key:index,staticClass:"list"},[_c('router-link',{attrs:{"to":{
          name: 'ProjectInfo',
          params: {
              id: item.id
          }
      }}},[_c('img',{attrs:{"src":item.picUrl,"alt":""}}),_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }